module.exports = __webpack_public_path__ + "img/icon-minus.cdebe0a8.svg";